module.exports = __webpack_public_path__ + "static/media/svgskilt_normalstopp-trackpoi_normal.2b54d032.svg";